import '../styles/spoofer-bar.scss';
import { HomepageContext } from '@amzn/brand-context-service-type-script-client';

export const renderSpooferBar = (context: HomepageContext): HTMLDivElement | null => {

  const { actualCustomerId, isSpoofer, targetCustomerId } = context;

  // Do not render spoofer bar if user is not a spoofer
  if (!isSpoofer) {
    return null;
  }

  const title = document.createElement('span');
  title.id = 'brand-registry-spoofer-title';
  title.textContent = 'Spoofer Enabled';

  const warning = document.createElement('span');
  warning.textContent = 'Actions will be logged and accessible by Amazon\'s Security team';

  const spooferTitleContainer = document.createElement('div');
  spooferTitleContainer.id = 'brand-registry-spoofer-title-container';
  spooferTitleContainer.append(title, warning);

  const actualId = document.createElement('b');
  actualId.textContent = actualCustomerId;

  const yourId = document.createElement('span');
  yourId.append('Your customer ID: ', actualId);

  const targetId = document.createElement('b');
  targetId.textContent = targetCustomerId;

  const spoofedId = document.createElement('span');
  spoofedId.append('Spoofed customer ID: ', targetId);

  const changeCustomerLink = document.createElement('a');
  changeCustomerLink.id = 'brand-registry-spoofer-change-customer-link';
  changeCustomerLink.href = '/internal/spoofer';
  changeCustomerLink.textContent = 'Change customer';

  const customerInfo = document.createElement('div');
  customerInfo.id = 'brand-registry-spoofer-customer-info-container';
  customerInfo.append(yourId, spoofedId, changeCustomerLink);

  const container = document.createElement('div');
  container.id = 'brand-registry-spoofer-container';
  container.append(spooferTitleContainer, customerInfo);

  return container;
};
